import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useCreateTextSet = () => {
  const createNewTextSet = useCallback((payload) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(`${MONOLITH_ORIGIN}/api/v2/text-set/`, requestParams);
  }, []);
  return useRestMutation(createNewTextSet);
};

export default useCreateTextSet;
